import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-default",
  "use": "icon-play-default-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play-default\"><path fill=\"#333333\" d=\"M454.4 400c6.4 0 32 3.2 86.4 38.4 76.8 48 96 70.4 99.2 80-6.4 9.6-25.6 32-99.2 80-54.4 35.2-80 41.6-89.6 41.6-3.2-6.4-16-32-16-121.6-3.2-99.2 16-118.4 19.2-118.4-3.2 0-3.2 0 0 0m0-64c-57.6 0-83.2 54.4-83.2 182.4 0 131.2 25.6 185.6 80 185.6 32 0 73.6-19.2 124.8-51.2 172.8-108.8 172.8-153.6 0-265.6C524.8 352 486.4 336 454.4 336zM512 995.2C246.4 995.2 28.8 777.6 28.8 512S246.4 28.8 512 28.8 995.2 246.4 995.2 512 777.6 995.2 512 995.2z m0-902.4C281.6 92.8 92.8 281.6 92.8 512S281.6 931.2 512 931.2 931.2 742.4 931.2 512 742.4 92.8 512 92.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/play-default.svg
// module id = OTIP
// module chunks = 65